import TranslationKeysForm from './package-rule-create-form'

export default TranslationKeysForm;